export default __webpack_public_path__ + "static/media/PackItUpLogo.e8660baa.png";